// Shared across every proposal: Adam's contact details, credentials, stats, eXp line, thank-you note and testimonials.
// Edit here once; every client's page picks it up.

export const agent = {
  name: "Adam Cothes",
  title: "Managing Broker",
  team: "Adam Home Team",
  brokerage: "eXp Realty",
  phone: "(425) 577-2676",
  phoneHref: "tel:+14255772676",
  smsHref: "sms:+14255772676",
  email: "adam@adamhometeam.com",
  website: "https://adamhometeam.com",
  calendly: "https://calendly.com/adam-cothes/15-minute-meeting",
  instagram: "https://www.instagram.com/adamcothes/",
  videoUrl: null,
  license: { value: "26794", verify: false },
  officeAddress: { value: "1455 Leary Way Ste 400, Seattle, WA 98107", verify: false },
  credentials: [
    "Managing Broker, Washington's highest real estate license",
    "Master Certified Negotiation Expert (MCNE)",
    "I teach contract and negotiation classes to other agents",
  ],
  negotiationQuote: "People love my marketing, but they appreciate my negotiation and risk management skills.",
  stats: [
    { value: 430, prefix: "", suffix: "+", label: "career sales", verify: false },
    { value: 400, prefix: "$", suffix: "M+", label: "total sales volume", verify: false },
    { display: "Top 10", label: "eXp agent in Washington, out of 1,500+", verify: false },
    { display: "$40M to $50M", label: "sold per year", verify: false },
  ],
  expLine: {
    value: "Brokered by eXp Realty, one of the largest independent brokerages, with almost 90,000 agents in 24 international markets.",
    verify: false,
  },
  thankYou: "Thank you for the opportunity to meet and discuss helping you sell your home! Selling a home can be a stressful process but it's my goal to help you make it smooth and enjoyable while netting the absolute most money possible!",
};

export const testimonials = [
  {
    name: "Ashley S.",
    quote: "Having worked with Adam twice, I cannot recommend highly enough! He is remarkably smart, knowledgeable, strategic and communicated throughout the entire process.",
  },
  {
    name: "Alex K.",
    quote: "Another agent tried to sell my home for 6 months. Adam took a completely different marketing approach and sold my home quickly for the best possible deal.",
  },
  {
    name: "Seth S.",
    quote: "Hands down the best negotiator with excellent people skills. They answered every question, helped us prepare the house for sale and viewing, and made sure we made sound choices to get top dollar out of our property.",
  },
  {
    name: "Earnie S.",
    quote: "Adam was organized, had a great plan, executed it perfectly, and helped us muddle through all of the offers his work generated so that we ended up getting the best price possible.",
  },
  {
    name: "Marc S.",
    quote: "He explained the process and his marketing campaign followed by a plan of action that made me comfortable… he not only sold my home, he also got us $21,000 over asking price!",
  },
];
